var NAV_ELEMS = ['span', 'div', 'button', 'a'];

export { NAV_ELEMS };
